import { render, staticRenderFns } from "./GStudentAllCompetencyFunChart.vue?vue&type=template&id=b0251a4c&scoped=true&"
import script from "./GStudentAllCompetencyFunChart.vue?vue&type=script&lang=ts&"
export * from "./GStudentAllCompetencyFunChart.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentAllCompetencyFunChart.vue?vue&type=style&index=0&id=b0251a4c&scoped=true&lang=scss&"
import style1 from "./GStudentAllCompetencyFunChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0251a4c",
  null
  
)

export default component.exports